<template>
    <div class="progressbar" :class="this.$store.getters.getterViewPerspectiveValue">

        <div class="progressbar-fill mobile-hide" :class="{'full': storyEnd}" :style="{width: (windowWidth - 80) / Object.keys($t('days')).length * (currentDay + this.progressbarBackward) + ((( ( (windowWidth - 80) / Object.keys($t('days')).length ) / ( ((Object.keys($t('days.day'+(currentDay + 1)+'.events')).length)+1) ) ) * (currentEventInDay + (Object.keys($t('days.day'+(currentDay+1)+'.events')).length > 1 ? 1 : 0))) -  0) + 'px'}"></div>

        <div class="progressbar-fill mobile-show" :class="{'full': storyEnd}" :style="{height: (windowHeight - 75) / Object.keys($t('days')).length * (currentDay + this.progressbarBackward) + 'px'}"></div>

        <div class="progressbar-inner mobile-hide">

            <div class="progressbar-tags" v-for="(day, key, index) in $t('days')" :key="index" :style="{width: 100 / Object.keys($t('days')).length + '%'}">

                <div class="progressbar-tags-group multiple" :class="{'active': index <= currentDay, 'event-past': index < currentDay}">

                    <p class="progressbar-tags-group-label mobile-hide" v-if="index == currentDay">
                        {{$t('days.day'+(currentDay+1)+'.events.event'+(currentEventInDay+1)+'.date')}}
                    </p>

                    <span class="progressbar-tags-group main" @click="loadDay(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><g id="Group_24" data-name="Group 24" transform="translate(-250 -678)" >
                            <circle class="fill" id="Ellipse_146" data-name="Ellipse 146" cx="2.5" cy="2.5" r="2.5" transform="translate(256 684)" fill="#717171"/><g id="Ellipse_145" data-name="Ellipse 145" transform="translate(253 681)" fill="none" stroke="#717171" stroke-width="1" opacity="0.7">
                            <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
                            <circle class="stroke" cx="5.5" cy="5.5" r="5" fill="none"/></g><g id="Ellipse_147" data-name="Ellipse 147" transform="translate(250 678)" fill="none" stroke="#717171" stroke-width="1" opacity="0.4">
                            <circle cx="8.5" cy="8.5" r="8.5" stroke="none"/>
                            <circle class="stroke" cx="8.5" cy="8.5" r="8" fill="none"/></g></g>
                        </svg>
                    </span>


                    <svg class="progressbar-tags-group fake" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4"><circle class="fill" id="Ellipse_151" data-name="Ellipse 151" cx="2" cy="2" r="2" fill="#fff"/></svg>

                    <span v-for="(item, key, childIndex) in day.events" :key="childIndex" @click="loadDay(index, childIndex)" class="progressbar-tags-group sub" :style="{left: ((( ( (windowWidth - 80) / Object.keys($t('days')).length ) / ( ((Object.keys($t('days.day'+(index + 1)+'.events')).length)+1) ) )  * (childIndex+1))-9) +'px'}"  :class="{'active': childIndex <= currentEventInDay && currentDay == index}">

                        <svg v-if="Object.keys(day.events).length > 1 "  xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4"><circle class="fill" id="Ellipse_151" data-name="Ellipse 151" cx="2" cy="2" r="2" fill="#555"/></svg>

                    </span>

                    <svg class="progressbar-tags-group fake" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4"><circle class="fill" id="Ellipse_151" data-name="Ellipse 151" cx="2" cy="2" r="2" fill="#fff"/></svg>

                    <div class="progressbar-tags-group-navigation">
                        <a href="#" v-for="(item, key, navIndex) in day.events" :key="navIndex" class="progressbar-tags-group-navigation-link" @click.prevent="loadDay(index, navIndex)" :class="{'active': currentDay == index && currentEventInDay == navIndex}">
                            {{item.shortTitle}}
                        </a>
                    </div>

                </div>

            </div>
        </div>

        <div class="progressbar-inner mobile-show">

            <div class="progressbar-tags" v-for="(day, key, index) in $t('days')" :key="index" :style="{height: 100 / Object.keys($t('days')).length + '%'}">

                <div class="progressbar-tags-group multiple" :class="{'active': index <= currentDay, 'event-past': index < currentDay}">

                    <p class="progressbar-tags-group-label mobile-hide" v-if="index == currentDay">
                        {{$t('days.day'+currentDay+'.events.event'+(currentEventInDay+1)+'.date')}}
                    </p>

                    <span class="progressbar-tags-group main" @click="loadDay(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><g id="Group_24" data-name="Group 24" transform="translate(-250 -678)" >
                            <circle class="fill" id="Ellipse_146" data-name="Ellipse 146" cx="2.5" cy="2.5" r="2.5" transform="translate(256 684)" fill="#717171"/><g id="Ellipse_145" data-name="Ellipse 145" transform="translate(253 681)" fill="none" stroke="#717171" stroke-width="1" opacity="0.7">
                            <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
                            <circle class="stroke" cx="5.5" cy="5.5" r="5" fill="none"/></g><g id="Ellipse_147" data-name="Ellipse 147" transform="translate(250 678)" fill="none" stroke="#717171" stroke-width="1" opacity="0.4">
                            <circle cx="8.5" cy="8.5" r="8.5" stroke="none"/>
                            <circle class="stroke" cx="8.5" cy="8.5" r="8" fill="none"/></g></g>
                        </svg>
                    </span>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Progressbar',
  data () {
    return {
      currentDay: 0,
      currentEventInDay: 0,
      progressbarBackward: 0,
      storyEnd: false,
      windowHeight: null,
      windowWidth: null,
    }
  },
  created() {
    window.addEventListener("load", this.myEventHandlerLoad);
    window.addEventListener("scroll", this.myEventHandlerScroll);
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("load", this.myEventHandlerLoad);
    window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("scroll", this.myEventHandlerScroll);
  },
  methods: {
    myEventHandlerScroll () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    },
    myEventHandlerLoad () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    },
    loadDay (index, subEventId = 0) {
      let _this = this
      setTimeout(function(){
        _this.currentEventInDay = subEventId
        _this.currentDay = index
      }, 800);
      this.$emit('show-custom-day', index, subEventId)
      this.$forceUpdate();
    },
    fullProgressBar () {
      this.storyEnd = true
    },
    removeFullProgressBar () {
      this.storyEnd = false
    },
    eventInViewport (index) {
      this.currentEventInDay = index
    },
    dayInViewport (dayId) {
      this.currentDay = dayId
    }
  }
}
</script>

